import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import artAndSoul from "../components/img/LessonsAndWorkshops/ArtAndSoul.jpeg";
import workshop1 from "../components/img/LessonsAndWorkshops/Workshop1.jpeg";
import butterfly from "../components/img/LessonsAndWorkshops/Butterfly.jpeg";
import dog from "../components/img/LessonsAndWorkshops/Dog.jpeg";
import donkey from "../components/img/LessonsAndWorkshops/Donkey.jpeg";
import dragon from "../components/img/LessonsAndWorkshops/Dragon.jpeg";
import lake1 from "../components/img/LessonsAndWorkshops/Lake.jpeg";
import lake2 from "../components/img/LessonsAndWorkshops/Lake2.jpeg";
import manandcat from "../components/img/LessonsAndWorkshops/manandcat.jpeg";
import mushroomScene from "../components/img/LessonsAndWorkshops/MushroomScene.jpeg";
import orangeFlower from "../components/img/LessonsAndWorkshops/OrangeFlower.jpeg";
import pinkFlower from "../components/img/LessonsAndWorkshops/PinkFlower.jpeg";
import queen from "../components/img/LessonsAndWorkshops/Queen.jpeg";
import sea from "../components/img/LessonsAndWorkshops/sea.jpeg";
import sunset from "../components/img/LessonsAndWorkshops/sunset.jpeg";
import tshirt from "../components/img/LessonsAndWorkshops/tshirt.jpeg";
import { Button, Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";

const ArtLessonsWorkshops = () => {
  const carouselImages = [
    { src: butterfly, alt: "Butterfly" },
    { src: dog, alt: "Dog" },
    { src: donkey, alt: "Donkey" },
    { src: dragon, alt: "Dragon" },
    { src: lake1, alt: "Lake" },
    { src: lake2, alt: "Lake view" },
    { src: manandcat, alt: "Man and cat" },
    { src: mushroomScene, alt: "Mushroom scene" },
    { src: orangeFlower, alt: "Orange flower" },
    { src: pinkFlower, alt: "Pink flower" },
    { src: queen, alt: "Queen" },
    { src: sea, alt: "Sea" },
    { src: sunset, alt: "Sunset" },
    { src: tshirt, alt: "T-shirt" },
  ];
  return (
    <div className="container my-5">
      <div className="text-center mb-4">
        <h1 className="display-4">Art & Crafts Classes in Rhos on Sea</h1>
        <p className="lead">
          A personal and creative experience in a small, focused setting.
        </p>
      </div>

      <div className="row mb-5">
        <div className="col-md-6">
          <img
            src={artAndSoul}
            alt="Crafts example"
            className="img-fluid rounded shadow-sm"
          />
        </div>
        <div className="col-md-6">
          <h3>Welcome to My Studio</h3>
          <p>
            I teach Art & Crafts from my studio in Rhos on Sea, offering
            tailored sessions for individuals or small groups (up to 4 people).
          </p>
          <p>
            I can provide you with my total undivided attention to teach every
            step from concept, planning, composition and techniques drawing out
            to finally colouring.
          </p>
          <p>
            You will have a choice of mediums such as charcoal, colour pencil,
            pastels, or paints. I let my students choose what they like to paint
            (although I do make suggestions) along the criteria of a person’s
            interest.
          </p>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-6">
          <h4>Session Highlights</h4>
          <ul className="list-group">
            <li className="list-group-item">2-hour sessions</li>
            <li className="list-group-item">
              Choice of mediums: charcoal, colour pencil, pastels, or paints
            </li>
            <li className="list-group-item">
              Subjects: landscapes, seascapes, animals, fantasy art
            </li>
            <li className="list-group-item">
              Crafts: glass painting, papier-mâché, polymer clay, and coasters
            </li>
            <li className="list-group-item">
              All materials and refreshments supplied
            </li>
          </ul>
          <h4 className="my-3">To Book</h4>
          <p>
            To book a session, please click{" "}
            <Link to="/contact-me/0" className="text-info">
              here
            </Link>{" "}
            and fill out the form provided
          </p>
          <p>
            If you have any further questions about the class. Please feel free
            to conatct me using the same link
          </p>
        </div>
        <div className="col-md-6">
          <img
            src={workshop1}
            alt="Crafts example"
            className="img-fluid rounded shadow-sm"
          />
        </div>
      </div>

      <div className="text-center mb-4">
        <h3>Pricing</h3>
        <p>
          All sessions offer personal guidance and a chance to create something
          you're proud of.
        </p>
      </div>
      <div className="row text-center">
        {[
          {
            title: "1-1 Session",
            price: "£40 pp",
            desc: "Personal attention. Tailored learning.",
          },
          {
            title: "Class of 2",
            price: "£30 pp",
            desc: "Small group learning experience.",
          },
          {
            title: "Class of 3",
            price: "£25 pp",
            desc: "Enjoy creativity with a couple of friends.",
          },
          {
            title: "Class of 4",
            price: "£20 pp",
            desc: "Affordable fun in a friendly group.",
          },
        ].map((item, index) => (
          <div className="col-md-3 mb-3" key={index}>
            <div className="card h-100 shadow">
              <div className="card-body">
                <h5 className="card-title">{item.title}</h5>
                <h6 className="card-subtitle mb-2 text-muted">
                  {item.price} / 2 hrs
                </h6>
                <p className="card-text">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center my-2">
        <h3>Weekend Course</h3>
        <p>Saturday & Sunday Timing May Vary</p>
      </div>

      <div className="row text-center">
        {[
          {
            title: "1 Person",
            price: "£160",
            desc: "Personal attention. Tailored learning.",
          },
          {
            title: "Class of 2",
            price: "£240",
            desc: "Small group learning experience.",
          },
          {
            title: "Class of 3",
            price: "£288",
            desc: "Enjoy creativity with a couple of friends.",
          },
          {
            title: "Class of 4",
            price: "£320",
            desc: "Affordable fun in a friendly group.",
          },
        ].map((item, index) => (
          <div className="col-md-3 mb-3" key={index}>
            <div className="card h-100 shadow">
              <div className="card-body">
                <h5 className="card-title">{item.title}</h5>
                <h6 className="card-subtitle mb-2 text-muted">
                  {item.price}
                </h6>
                <h6 className="card-subtitle mb-2 text-muted">4hrs (5hrs including hour for lunch)</h6>
                <p className="card-text">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5 p-4 bg-light rounded shadow-sm">
        <h4>Session Details</h4>
        <p>
          Each session will be 4 hours total, with a two hour session in the
          morning followed by lunch. And then another two hour session in the
          afternoon.
        </p>
      </div>
      <div className="mt-5 p-4 bg-light rounded shadow-sm">
        <h4>Why Choose Me?</h4>
        <p>
          My classes are not the cheapest — and that’s because they’re tailored
          just for you. You’ll get a unique experience, one-on-one support, and
          you won’t have to follow a cookie-cutter project. Whether you’re new
          or experienced, I’ll work with you to make sure your first piece is
          something to be proud of!
        </p>
        <p>
          <strong>Recommendation:</strong> Book a 1-1 session first so I can
          understand your interests and skills.
        </p>
      </div>

      <div className="mt-5 p-4 bg-light rounded shadow-sm">
        <h4>Paintings from customers</h4>
        <Carousel
        variant="dark"
          autoPlay={true}
          interval={3500}
          className="mb-5 rounded-4 mx-auto"
          showStatus={true}
          showThumbs={true}
          infiniteLoop
          style={{ width: "80%" }}
        >
          {carouselImages.map((image, index) => (
            <Carousel.Item key={index}>
              <img
                src={image.src}
                alt={image.alt}
                className="d-block w-100 carousel-image"
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
      <div className="row my-4">
        <Button
          as={Link}
          to={`/contact-me/0`}
          className="btn btn-primary my-4 buy px-5 py-2 text-white artwork-shipping"
          style={{
            backgroundColor: "#008080",
            border: "none",
            color: "#FFFFFF",
          }}
        >
          <span className="buttonText fs-3 fw-bolder">Book Now</span>
        </Button>
      </div>
    </div>
  );
};

export default ArtLessonsWorkshops;
